import Stat from 'Shared/components/Stat'
import ActionHeader from './ActionHeader'
import useActionLabel from '../../useActionLabel'
import './ActionStats.scoped.scss'
import '../FlowStats.scoped.scss'

export default function Donate({ flowId, actionId, removed }) {
  const { stats } = useSel((s) => s.flow)
  const label = useActionLabel('donate')

  // Organize stats by currency
  const currencyGroups = []
  const hasMultipleCurrencies = stats?.donationsByCurrency && stats.donationsByCurrency.length > 1

  if (stats?.donationsByCurrency && stats.donationsByCurrency.length > 0) {
    // Multi-currency or single currency (new format)
    stats.donationsByCurrency.forEach(curr => {
      currencyGroups.push({
        currency: curr.currency,
        symbol: curr.symbol,
        stats: [
          { label: 'Amount raised', value: `${curr.symbol}${curr.sum.toFixed(2)}` },
          { label: 'Average donation amount', value: `${curr.symbol}${curr.average.toFixed(2)}` }
        ]
      })
    })
  } else if (stats?.donationsSum !== undefined) {
    // Legacy fallback: single currency
    const symbol = stats?.donationCurrencySymbol || '£'
    currencyGroups.push({
      currency: 'legacy',
      symbol: symbol,
      stats: [
        { label: 'Amount raised', value: `${symbol}${stats.donationsSum || 0}` },
        { label: 'Average donation amount', value: `${symbol}${stats.donationsAverage || 0}` }
      ]
    })
  }

  return (
    <div className="flow-action-stats">
      <div className='box margin-top double no-side-padding no-bottom-padding' id='donate'>
        <div className="donate-header">
          <ActionHeader flowId={flowId} actionId={actionId} title={`${label}${removed ? ' (removed)' : ''}`} />
        </div>

        {/* Show each currency group */}
        {currencyGroups.map((group, groupIndex) => (
          <div className='currency-row' key={`currency-${group.currency}`}>
            {hasMultipleCurrencies && (
              <h3>{group.currency}</h3>
            )}
            <div className='box grid'>
              {group.stats.map((stat, index) => (
                <div className="stat-container" key={`${group.currency}-${index}`}>
                  <Stat
                    borderBottom={false}
                    size={'vertical'}
                    label={stat.label}
                    primary={stat.value}
                  />
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
